import React, { useEffect, useContext, useState } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import ButtonOutline from '../../componentes/ui/ButtonOutline';
import MiSelect from '../../componentes/formulario/MiSelect';
import swal from 'sweetalert';
import Spinner from 'react-bootstrap/Spinner';
import useLogicForm from '../../hooks/useLogicForm';
import Cookies from 'universal-cookie';
import { MiReplaceAll, getApiUrl, stringToHtml, axiosPost, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';
import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';

function ImpAge(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ respuestaImpAge, saveRespuestaImpAge ] = useState("");
    const [ loading, saveLoading ] = useState(false);

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confApp.impage.section.titulo);
                    if( getDecodedCookie('nivel') == 1 || getDecodedCookie('nivel') == 2 || getDecodedCookie('nivel') == 3 ){
                        if( respuesta == 1 ){
                            saveTieneNivel(true);                                                                            
                        }
                        else if( respuesta == 0 ){
                            saveTieneNivel(false);
                        }
                    }else{
                        saveTieneNivel(false);
                    }                                        

                    saveLoadedConf(true);
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                let input = document.getElementById('inputAge');
                if( input ){
                    input.remove();
                }
                
                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla, respuestaImpAge])
    

    const importAge = () => {                

        let inputFile;        
        if( !document.getElementById('inputAge') ){
            inputFile = document.createElement('input');
            inputFile.setAttribute('id','inputAge');
            inputFile.setAttribute('type','file');
            inputFile.style.display = 'none';
            // inputFile.setAttribute('accept','.csv, .xls, .xlsx ');
            inputFile.setAttribute('enctype','multipart/form-data');
            document.body.appendChild(inputFile);            
        }else{
            inputFile = document.getElementById('inputAge')
        }
        
        inputFile.addEventListener('change', handleFileImportAge, false);
        inputFile.click(); 
        
    }

    const handleFileImportAge = async () => {         
        let inputFile = document.getElementById('inputAge');          
        const file_data = inputFile.files[0];
        //Validamos la extensión        
        if( !validateExtension(file_data, ['csv','xls','xlsx']) ){
            if( file_data ){
                swal("Error", `${file_data["name"]} ${confPantalla.config.trad.components.importador.errorfiletype.title}`, "error");                   
            }
        }else{
            saveLoading(true); 
            
            saveRespuestaImpAge("");

            let data = new FormData();                  
            data.append('file', file_data);
            data.append('tabimp', "agentes");            
            data.append("validacion", apiKey());  
    
            const url = `${getApiUrl(window.location.origin)}/app/FileToDB`;
            // const res = await axios.post(url, data); 
            const res = await axiosPost(url, data, source.token);   

            saveRespuestaImpAge(res.data);
        }
        // document.getElementById('inputAge').value = "";     
        saveLoading(false);                               
   
    }

    const validateExtension = (file, extensiones) => {
        if( file ){
            let fileExtension = file["name"].split(".")[file["name"].split(".").length-1];
            const valido = extensiones.find(ext => fileExtension.toLowerCase() == ext.toLowerCase());
            return valido;
        }
    }

    return(
        <div className="App wrapper">   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                            <Section 
                                    titulo={confApp.impage.section.titulo} 
                                    icono={confApp.impage.section.icono} 
                                    col={confApp.impage.section.col} 
                                    wiki={confApp.impage.section.wiki}                                    
                            >
                            <div className="card">
                                <div className="card-header">
                                    <i className="fal fa-info-circle fa-2x" style={{color: "#212529"}}></i>
                                </div>
                                <div className="card-body">
                                    <blockquote className="blockquote mb-0" style={{borderLeft : "none"}}>
                                        <p>{confApp.impage.blockquote.titulo}</p>
                                        <footer className="blockquote-footer">
                                            <cite>
                                                <a className='ml-1' href={"/assets/_files/PLANTILLA_IMPORTACION_AGENTES.xlsx"} download="PLANTILLA_IMPORTACION_AGENTES.xlsx">
                                                    {confApp.impage.blockquote.a.titulo}
                                                </a>
                                            </cite>
                                        </footer>
                                    </blockquote>
                                    <blockquote className="blockquote mb-0" style={{borderLeft : "none"}}>                                        
                                        <footer className="blockquote-footer">
                                            <cite className='mt-4'>                                                
                                                {confApp.impage.blockquote.help.titulo}                                                
                                            </cite>                                           
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>                            
                            <ButtonOutline
                                clases={ "col-12 mt-2" }
                                color={ "success" } 
                                type="button" 
                                icono={ "mr-1 fal fa-file-upload" }   
                                id=""     
                                texto={confApp.impage.btnupload.titulo}   
                                accion={ importAge } 
                                disabled={ false }
                            />
                            {
                                loading ?
                                    <div className='mt-3 text-center'>
                                        <Spinner animation="border" />
                                    </div>                                 
                                :
                                    null
                            }
                            {
                                respuestaImpAge != "" ?
                                    <div className='mt-4'>
                                        <div className="alert alert-success" role="alert" 
                                             dangerouslySetInnerHTML={stringToHtml(respuestaImpAge)}
                                        >
                                        </div>
                                    </div>
                                :
                                    null
                            }
    
                                                                
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default ImpAge